import {
  findSchedulesByProcedures,
} from '@/app/(main)/(pages)/busca/[slug]/_services/find-schedules-by-procedures.service';
import { SearchFilterDayTimeType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-day-time.type';
import { SearchFilterProfessionalGenderType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-filter-professional-gender.type';
import { slugify } from '@/utils/formatters/slugfy';

export interface GetSchedulesPreviewFromSearchApiParams {
  procedureIds: string[];
  city?: string;
  state?: string;
  latitude?: number;
  longitude?: number;
  distance?: number;
  dayTime?: SearchFilterDayTimeType;
  professionalGender?: SearchFilterProfessionalGenderType;
  minAge?: number;
  maxAge?: number;
  minDate?: string;
  maxDate?: string;
  followUp?: boolean;
  onlyScheduled?: boolean;
}

export async function getSchedulesPreviewFromSearchApi(
  params: GetSchedulesPreviewFromSearchApiParams,
): Promise<boolean> {
  if (params.procedureIds.length === 0) {
    return false;
  }

  const citySlug = params.city
    ? slugify(params.state ? `${params.city}-${params.state}` : params.city)
    : undefined;

  const { groups } = await findSchedulesByProcedures({
    procedureIds: params.procedureIds,
    city: citySlug,
    latitude: params.latitude,
    longitude: params.longitude,
    distance: params.distance,
    dayTime: params.dayTime,
    professionalGender: params.professionalGender,
    minAge: params.minAge,
    maxAge: params.maxAge,
    minDate: params.minDate,
    maxDate: params.maxDate,
    followUp: params.followUp,
    onlyScheduled: params.onlyScheduled,
    page: 1,
    limit: 1,
  });

  return groups.length > 0;
}
